import { useState } from "react";
import { IoBusiness } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../services/api";

export default function ConfiguracaoInicial() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [nome, setNome] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nome.trim()) {
      setError("Informe o nome da fazenda.");
      return;
    }

    setError("");
    setLoading(true);
    try {
      const response = await api.post("/configuracoes/primeira-fazenda/", { nome });
      const { access, refresh, user, fazenda, cargo, permissoes, must_change_password } = response.data;

      login(user, access, fazenda, permissoes, cargo, refresh, must_change_password);
      navigate(must_change_password ? "/trocar-senha" : "/dashboard");
    } catch (err) {
      console.error("Erro ao criar primeira fazenda:", err);
      setError(err.response?.data?.detail || "Não foi possível criar a fazenda.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
        <div className="flex items-center gap-2 mb-2">
          <IoBusiness size={28} className="text-green-700" />
          <h1 className="text-xl font-bold text-gray-800">Configuração inicial</h1>
        </div>
        <p className="text-sm text-gray-600 mb-6">
          Sua empresa foi cadastrada. Agora crie a primeira fazenda para começar a usar o sistema.
        </p>

        {error && (
          <div className="mb-4 p-3 rounded-lg bg-red-100 text-red-700 border border-red-200 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nome da Fazenda
            </label>
            <input
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-400 focus:border-green-400"
              placeholder="Ex.: Fazenda Santa Rita"
              required
              autoFocus
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-green-700 hover:bg-green-800 disabled:bg-green-400 text-white font-semibold py-2.5 rounded-lg transition-colors"
          >
            {loading ? "Criando..." : "Criar fazenda e entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
